var map = {
	"./PANO_20131220_215649.jpg": "7+vl",
	"./PANO_20131223_221316.jpg": "/X0l",
	"./PANO_20140111_174941.jpg": "YH1O",
	"./PANO_20140116_155642.jpg": "3X2G",
	"./prize-and-awards/d22013.jpg": "u+i7",
	"./prize-and-awards/imagine-cup.jpg": "uCg3",
	"./profile.png": "7pzU"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";